import { Link } from "react-router-dom";
import { LEGAL_LINKS, SELLER } from "../content/legal";

// Replaces {email} / {terms} / {refund} / {privacy} / {pricing} tokens in the
// text from content/legal.js with real links.
export function renderInline(text) {
  return text.split(/(\{\w+\})/g).map((part, i) => {
    const token = /^\{(\w+)\}$/.exec(part)?.[1];
    if (token === "email") {
      return (
        <a key={i} className="underline" href={`mailto:${SELLER.email}`}>
          {SELLER.email}
        </a>
      );
    }
    if (token && LEGAL_LINKS[token]) {
      return (
        <Link key={i} className="underline" to={LEGAL_LINKS[token].path}>
          {LEGAL_LINKS[token].label}
        </Link>
      );
    }
    return part;
  });
}
